module.exports = __webpack_public_path__ + "static/media/icon_front.e7bdb31a.svg";